import { useDataEntryContext } from "../../context/reducer.provider";
import { useJustifyAllStrandLosses } from "../../hooks/useJustifyAllStrandLosses";
import { getStrandAssets } from "../../utils/strand-losses/getStrandAssets";
import { JustifyStrandLossesModal } from "./JustifyStrandLossesModal";

export const JustifyAllStrandLossesModal = () => {
  const {
    state: { deProcess },
  } = useDataEntryContext();
  const { showJustifyAll, isJustifyingAll, closeJustifyAll, justifyAll } =
    useJustifyAllStrandLosses();

  if (!showJustifyAll) return null;

  const parentAssetId =
    getStrandAssets(deProcess?.strands ?? [])[0]?.ParentAssetId ?? null;

  return (
    <JustifyStrandLossesModal
      isSubmitting={isJustifyingAll}
      onClose={closeJustifyAll}
      onConfirm={justifyAll}
      parentAssetId={parentAssetId}
    />
  );
};
